export const observe = (sel: string, opt: any, cb: any) => {
  const Obs = new MutationObserver((mutations: any[]) =>
    [...mutations].forEach(cb)
  );
  document.querySelectorAll(sel).forEach((el) => Obs.observe(el, opt));
};
